<template>
  <html>
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta http-equiv="Content-Style-Type" content="text/css" />
      <meta name="generator" content="Aspose.Words for .NET 17.1.0.0" />
      <title />
    </head>
  </html>
</template>
<script>
import { GetManagerLoginConfig } from '@/api/login';
export default {
  created() {
    console.log('created', this.$route.params);
    // this.$store.dispatch('user/getManagerLogin').then((res) => {
    //   console.log('21123', res);
    // });
    this.getCode();
  },
  methods: {
    getCode() {
      console.log('getcode');
      const code = this.query('code');
      console.log('code', code);
      const { redirecturl } = this.$route.params;
      const decodedUrl = atob(redirecturl);
      if (code) {
        // console.log('code', code);
        // const paramReg = /\?\w=/;
        // if (paramReg.test(decodedUrl)) {
        //   window.location.replace(`${decodedUrl}&ticket=${code}`);
        //   return;
        // }
        // window.location.replace(`${decodedUrl}?ticket=${code}`);
        // return;
        const url = this.replaceParam('ticket', code, decodedUrl, true);
        console.log('url', url);
        window.location.replace(url);
      } else {
        GetManagerLoginConfig({
          tenant_id: 10000,
        }).then((res) => {
          console.log('res', res);
          const appid = res.qiye_corpid || 'wwf48366fdd583429b';
          window.location.replace(
            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
              location.href,
            )}&response_type=code&scope='snsapi_base'&state=0#wechat_redirect`,
          );
        });
      }
    },
    query(query, url) {
      query = query.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      const expr = `[\\?&]${query}=([^&#]*)`;
      const regex = new RegExp(expr);
      url = url || window.location.href;
      const results = regex.exec(url);
      if (results !== null) {
        return decodeURIComponent(results[1].replace(/\+/g, ' '));
      }
      return '';
    },
    replaceParam(param, value, url, forceReplace) {
      // 替换参数，添加ptag等
      if (!value && !forceReplace) {
        return url;
      }
      const urlArr = (url || '').split('#');
      [url] = urlArr;
      const reg = new RegExp(`([\\?&]${param}=)[^&#]*`);
      if (!url.match(reg)) {
        url = !url.includes('?') ? `${url}?${param}=${value}` : `${url}&${param}=${value}`;
      }
      if (forceReplace) {
        url = url.replace(reg, `$1${value}`);
      }
      if (!value) {
        // 删除该参数
        url = url
          .replace(new RegExp(`(\\?|&)${param}=[^&]*(&)?`, 'g'), (p0, p1, p2) =>
            p1 === '?' || p2 ? p1 : '',
          )
          .replace(/\?$/, '');
      }
      if (urlArr.length > 1) {
        url += `#${urlArr.slice(1).join('#')}`;
      }
      return url;
    },
    replaceParams(params, url, forceReplace = false) {
      // param为obj
      const urlArr = (url || '').split('#');
      [url] = urlArr;
      Object.keys(params).forEach((key) => {
        url = this.replaceParam(key, params[key], url, forceReplace);
      });
      if (urlArr.length > 1) {
        url += `#${urlArr.slice(1).join('#')}`;
      }
      return url;
    },
  },
};
</script>
<style scoped lang="scss"></style>
